(function () {
  "use strict";

  angular
    .module("app")
    .service("routeSyncErrors", routeSyncErrors);

  routeSyncErrors.$inject = [
    "$translate",
    "_"
  ];

  function routeSyncErrors($translate, _) {

    return {
      areRouteOptionsValid: areRouteOptionsValid,
      getErrorsFromRouteOptions: getErrorsFromRouteOptions
    };

    ////////////////

    /** areRouteOptionsValid
     *  Returns whether or not the route has options that are valid for routeSync.
     * @param {Object} route - the route that contains the options we want to validate
     */
    function areRouteOptionsValid(route) {
      if (!route || !route.options)
        return false;

      if (route.options.highwayOnly === true) {
        return false;
      }

      if (route.options.overrideRestrict === true) {
        return false;
      }

      return true;
    }

    /** getErrorsFromRouteOptions
     *  Returns the translated error string that describes why the route's options prevent
     *  it from being valid for route sync.
     * @param {*} route - the route that contains the options for which we are getting errors
     */
    function getErrorsFromRouteOptions(route) {
      if (!route || !route.options)
        return "";

      var highwayOnly = route.options.highwayOnly === true;
      var overrideRestrict = route.options.overrideRestrict === true;
      if (highwayOnly && overrideRestrict) {
        return $translate.instant("templates.routeSyncErrors.useHighwayOnlyAndOverrideRestrictionsMessage");
      } else if (highwayOnly) {
        return $translate.instant("templates.routeSyncErrors.useHighwayOnlyMessage");
      } else if (overrideRestrict) {
        return $translate.instant("templates.routeSyncErrors.overrideRestrictionsMessage");
      } else {
        return "";
      }
    }
  }
})();



// WEBPACK FOOTER //
// ./app/route-sync/route-sync-utils/routeSyncErrors.service.js